export const translations = {
  fr: {
    meta: {
      title: "FLEN Immobilier | Votre partenaire immobilier en Suisse",
      description: "FLEN Immobilier vous accompagne dans vos projets de vente, d'acquisition et d'investissement immobilier avec expertise, exigence et discrétion.",
    },
    nav: {
      expertise: "Expertise",
      about: "À propos",
      contact: "Contact",
      cta: "Parlons de votre projet",
      openMenu: "Ouvrir le menu",
      closeMenu: "Fermer le menu",
    },
    hero: {
      line1: "L'immobilier,",
      line2: "autrement.",
      sub: "Vendre · Acquérir · Investir",
      cta: "Parlons de votre projet",
      scroll: "Faites défiler pour explorer",
      alt: "Villa moderne suisse au crépuscule — architecture contemporaine",
    },
    intro: {
      label: "FLEN Immobilier",
      headline: "Une autre manière de penser l'immobilier.",
      text: "FLEN Immobilier accompagne ses clients dans leurs projets immobiliers avec une approche fondée sur l'écoute, la précision et la discrétion.",
    },
    marquee: ["Vendre", "Acquérir", "Investir", "Estimation", "Conseil", "Discrétion"],
    expertise: {
      label: "Ce que nous faisons",
      headline: "Notre expertise",
      items: [
        {
          num: "01",
          title: "Vendre",
          text: "Une stratégie sur mesure pour révéler la valeur de votre bien et atteindre les bons acquéreurs.",
        },
        {
          num: "02",
          title: "Acquérir",
          text: "Une sélection rigoureuse et un accompagnement personnalisé pour trouver le bien qui vous correspond.",
        },
        {
          num: "03",
          title: "Investir",
          text: "Une vision stratégique de l'immobilier pour identifier les opportunités et créer de la valeur.",
        },
      ],
    },
    emotional: {
      headline: "L'exigence dans chaque détail.",
      text: "De la première rencontre à la signature, chaque projet mérite une attention particulière.",
      alt: "Rives du lac Léman — paysage suisse au bord de l'eau",
    },
    approach: {
      label: "Pourquoi FLEN",
      headline: "Notre approche",
      items: [
        { num: "01", title: "Expertise", text: "Une connaissance précise du marché." },
        { num: "02", title: "Discrétion", text: "Des échanges confidentiels et personnalisés." },
        { num: "03", title: "Exigence", text: "Chaque détail compte." },
        { num: "04", title: "Engagement", text: "Un accompagnement à chaque étape." },
      ],
    },
    cta: {
      headline: "Votre projet mérite une autre approche.",
      sub: "Parlons-en.",
      button: "Prendre contact",
    },
    contact: {
      label: "Contact",
      headline: "Parlons de votre projet.",
      subtitle: "Vous souhaitez vendre, acquérir ou investir ? Échangeons en toute confidentialité.",
      firstName: "Prénom",
      lastName: "Nom",
      email: "E-mail",
      phone: "Téléphone",
      project: "Votre projet",
      projectOptions: ["Vente", "Acquisition", "Investissement", "Estimation", "Autre"],
      message: "Message",
      submit: "Envoyer ma demande",
      sending: "Envoi en cours…",
      successTitle: "Merci pour votre message.",
      successText: "Nous revenons vers vous dans les meilleurs délais.",
      errorText: "Une erreur est survenue. Veuillez réessayer ou nous écrire directement par e-mail.",
      required: "Ce champ est requis.",
      propertyInquiry: "Bien concerné",
      emailLabel: "E-mail",
      phoneLabel: "Téléphone",
      locationLabel: "Adresse",
      locationValue: "Avenue de Granges-Paccot 2 · 1700 Fribourg",
    },
    footer: {
      navTitle: "Navigation",
      contactTitle: "Contact",
      home: "Accueil",
      legalMentions: "Mentions légales",
      legalPrivacy: "Politique de confidentialité",
      rights: "© 2026 FLEN Immobilier",
      email: "info@flen-immobilier.ch",
      location: "Avenue de Granges-Paccot 2 · 1700 Fribourg",
    },
    legal: {
      backHome: "Retour à l'accueil",
      updated: "Dernière mise à jour : août 2026",
      mentions: {
        title: "Mentions légales",
        sections: [
          {
            h: "Éditeur du site",
            p: "FLEN Immobilier\nAvenue de Granges-Paccot 2\n1700 Fribourg, Suisse\nE-mail : info@flen-immobilier.ch\nNuméro IDE : CHE-419.152.950",
          },
          {
            h: "Propriété intellectuelle",
            p: "L'ensemble des contenus de ce site (textes, images, logotypes, éléments graphiques) est la propriété exclusive de FLEN Immobilier. Toute reproduction, distribution ou utilisation sans autorisation écrite préalable est interdite.",
          },
          {
            h: "Limitation de responsabilité",
            p: "FLEN Immobilier s'efforce d'assurer l'exactitude des informations publiées, sans pouvoir en garantir l'exhaustivité ni l'actualité. Toute responsabilité pour des dommages résultant de l'utilisation de ce site est exclue dans les limites permises par la loi. Ce site peut contenir des liens vers des sites tiers, pour lesquels FLEN Immobilier décline toute responsabilité.",
          },
          {
            h: "Droit applicable",
            p: "Le présent site ainsi que ces mentions légales sont soumis au droit suisse. Le for exclusif est Fribourg, sous réserve de fors impératifs.",
          },
        ],
      },
      privacy: {
        title: "Politique de confidentialité",
        sections: [
          {
            h: "Responsable du traitement",
            p: "FLEN Immobilier, Avenue de Granges-Paccot 2, 1700 Fribourg, Suisse (info@flen-immobilier.ch), est responsable du traitement des données personnelles collectées via ce site, conformément à la loi fédérale sur la protection des données (nLPD).",
          },
          {
            h: "Données collectées",
            p: "Lorsque vous utilisez notre formulaire de contact, nous collectons les données que vous nous transmettez : prénom, nom, adresse e-mail, numéro de téléphone (facultatif), type de projet et message. Ces données sont utilisées exclusivement pour traiter votre demande et vous recontacter.",
          },
          {
            h: "Transmission à des tiers",
            p: "Vos données ne sont ni vendues ni transmises à des tiers à des fins commerciales. Elles peuvent être traitées par des prestataires techniques (hébergement du site, service d'envoi d'e-mails) dans la stricte mesure nécessaire au fonctionnement de nos services.",
          },
          {
            h: "Statistiques d'utilisation",
            p: "Ce site utilise un outil d'analyse d'audience afin d'améliorer l'expérience utilisateur. Les données collectées à cette fin sont traitées de manière agrégée.",
          },
          {
            h: "Durée de conservation",
            p: "Nous conservons vos données uniquement le temps nécessaire au traitement de votre demande et aux éventuels échanges qui en découlent, sauf obligation légale de conservation plus longue.",
          },
          {
            h: "Vos droits",
            p: "Vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles. Pour exercer ces droits ou pour toute question relative à la protection des données, écrivez-nous à info@flen-immobilier.ch.",
          },
          {
            h: "Modifications",
            p: "FLEN Immobilier se réserve le droit d'adapter la présente politique de confidentialité. La version en vigueur est celle publiée sur ce site.",
          },
        ],
      },
    },
  },

  de: {
    meta: {
      title: "FLEN Immobilier | Ihr Immobilienpartner in der Schweiz",
      description: "FLEN Immobilier begleitet Sie bei Verkauf, Erwerb und Investition mit Expertise, Anspruch und Diskretion.",
    },
    nav: {
      expertise: "Expertise",
      about: "Über uns",
      contact: "Kontakt",
      cta: "Sprechen wir über Ihr Projekt",
      openMenu: "Menü öffnen",
      closeMenu: "Menü schliessen",
    },
    hero: {
      line1: "Immobilien,",
      line2: "anders gedacht.",
      sub: "Verkaufen · Erwerben · Investieren",
      cta: "Sprechen wir über Ihr Projekt",
      scroll: "Scrollen zum Entdecken",
      alt: "Moderne Schweizer Villa in der Abenddämmerung — zeitgenössische Architektur",
    },
    intro: {
      label: "FLEN Immobilier",
      headline: "Eine andere Art, Immobilien zu denken.",
      text: "FLEN Immobilier begleitet seine Kunden bei ihren Immobilienprojekten mit einem Ansatz, der auf Zuhören, Präzision und Diskretion basiert.",
    },
    marquee: ["Verkaufen", "Erwerben", "Investieren", "Schätzung", "Beratung", "Diskretion"],
    expertise: {
      label: "Was wir tun",
      headline: "Unsere Expertise",
      items: [
        {
          num: "01",
          title: "Verkaufen",
          text: "Eine massgeschneiderte Strategie, um den Wert Ihrer Immobilie sichtbar zu machen und die richtigen Käufer zu erreichen.",
        },
        {
          num: "02",
          title: "Erwerben",
          text: "Eine rigorose Auswahl und persönliche Begleitung, um die Immobilie zu finden, die zu Ihnen passt.",
        },
        {
          num: "03",
          title: "Investieren",
          text: "Eine strategische Sicht auf Immobilien, um Chancen zu erkennen und Werte zu schaffen.",
        },
      ],
    },
    emotional: {
      headline: "Anspruch in jedem Detail.",
      text: "Vom ersten Treffen bis zur Unterschrift verdient jedes Projekt besondere Aufmerksamkeit.",
      alt: "Ufer des Genfersees — Schweizer Landschaft am Wasser",
    },
    approach: {
      label: "Warum FLEN",
      headline: "Unser Ansatz",
      items: [
        { num: "01", title: "Expertise", text: "Eine präzise Kenntnis des Marktes." },
        { num: "02", title: "Diskretion", text: "Vertraulicher und persönlicher Austausch." },
        { num: "03", title: "Anspruch", text: "Jedes Detail zählt." },
        { num: "04", title: "Engagement", text: "Begleitung bei jedem Schritt." },
      ],
    },
    cta: {
      headline: "Ihr Projekt verdient einen anderen Ansatz.",
      sub: "Sprechen wir darüber.",
      button: "Kontakt aufnehmen",
    },
    contact: {
      label: "Kontakt",
      headline: "Sprechen wir über Ihr Projekt.",
      subtitle: "Sie möchten verkaufen, erwerben oder investieren? Tauschen wir uns vertraulich aus.",
      firstName: "Vorname",
      lastName: "Name",
      email: "E-Mail",
      phone: "Telefon",
      project: "Ihr Projekt",
      projectOptions: ["Verkauf", "Erwerb", "Investition", "Schätzung", "Anderes"],
      message: "Nachricht",
      submit: "Anfrage senden",
      sending: "Wird gesendet…",
      successTitle: "Vielen Dank für Ihre Nachricht.",
      successText: "Wir melden uns schnellstmöglich bei Ihnen.",
      errorText: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut oder schreiben Sie uns direkt per E-Mail.",
      required: "Dieses Feld ist erforderlich.",
      propertyInquiry: "Objekt",
      emailLabel: "E-Mail",
      phoneLabel: "Telefon",
      locationLabel: "Adresse",
      locationValue: "Avenue de Granges-Paccot 2 · 1700 Fribourg",
    },
    footer: {
      navTitle: "Navigation",
      contactTitle: "Kontakt",
      home: "Startseite",
      legalMentions: "Impressum",
      legalPrivacy: "Datenschutzerklärung",
      rights: "© 2026 FLEN Immobilier",
      email: "info@flen-immobilier.ch",
      location: "Avenue de Granges-Paccot 2 · 1700 Fribourg",
    },
    legal: {
      backHome: "Zurück zur Startseite",
      updated: "Letzte Aktualisierung: August 2026",
      mentions: {
        title: "Impressum",
        sections: [
          {
            h: "Herausgeberin der Website",
            p: "FLEN Immobilier\nAvenue de Granges-Paccot 2\n1700 Fribourg, Schweiz\nE-Mail: info@flen-immobilier.ch\nUID-Nummer: CHE-419.152.950",
          },
          {
            h: "Geistiges Eigentum",
            p: "Sämtliche Inhalte dieser Website (Texte, Bilder, Logos, grafische Elemente) sind ausschliessliches Eigentum von FLEN Immobilier. Jede Vervielfältigung, Verbreitung oder Verwendung ohne vorherige schriftliche Zustimmung ist untersagt.",
          },
          {
            h: "Haftungsbeschränkung",
            p: "FLEN Immobilier bemüht sich um die Richtigkeit der veröffentlichten Informationen, kann jedoch deren Vollständigkeit und Aktualität nicht garantieren. Eine Haftung für Schäden aus der Nutzung dieser Website ist im gesetzlich zulässigen Rahmen ausgeschlossen. Diese Website kann Links zu Websites Dritter enthalten, für die FLEN Immobilier jede Verantwortung ablehnt.",
          },
          {
            h: "Anwendbares Recht",
            p: "Diese Website sowie dieses Impressum unterstehen schweizerischem Recht. Ausschliesslicher Gerichtsstand ist Freiburg, vorbehältlich zwingender Gerichtsstände.",
          },
        ],
      },
      privacy: {
        title: "Datenschutzerklärung",
        sections: [
          {
            h: "Verantwortliche Stelle",
            p: "FLEN Immobilier, Avenue de Granges-Paccot 2, 1700 Fribourg, Schweiz (info@flen-immobilier.ch), ist verantwortlich für die Bearbeitung der über diese Website erhobenen Personendaten gemäss Bundesgesetz über den Datenschutz (revDSG).",
          },
          {
            h: "Erhobene Daten",
            p: "Bei Nutzung unseres Kontaktformulars erheben wir die von Ihnen übermittelten Daten: Vorname, Name, E-Mail-Adresse, Telefonnummer (freiwillig), Art des Projekts und Nachricht. Diese Daten werden ausschliesslich zur Bearbeitung Ihrer Anfrage und zur Kontaktaufnahme verwendet.",
          },
          {
            h: "Weitergabe an Dritte",
            p: "Ihre Daten werden weder verkauft noch zu kommerziellen Zwecken an Dritte weitergegeben. Sie können durch technische Dienstleister (Hosting der Website, E-Mail-Versanddienst) bearbeitet werden, soweit dies für den Betrieb unserer Dienste erforderlich ist.",
          },
          {
            h: "Nutzungsstatistiken",
            p: "Diese Website verwendet ein Analyse-Tool zur Verbesserung der Benutzererfahrung. Die zu diesem Zweck erhobenen Daten werden aggregiert bearbeitet.",
          },
          {
            h: "Aufbewahrungsdauer",
            p: "Wir bewahren Ihre Daten nur so lange auf, wie es für die Bearbeitung Ihrer Anfrage und die daraus folgenden Austausche erforderlich ist, sofern keine gesetzliche Aufbewahrungspflicht besteht.",
          },
          {
            h: "Ihre Rechte",
            p: "Sie haben das Recht auf Auskunft, Berichtigung und Löschung Ihrer Personendaten. Zur Ausübung dieser Rechte oder bei Fragen zum Datenschutz schreiben Sie uns an info@flen-immobilier.ch.",
          },
          {
            h: "Änderungen",
            p: "FLEN Immobilier behält sich vor, diese Datenschutzerklärung anzupassen. Es gilt die auf dieser Website veröffentlichte Version.",
          },
        ],
      },
    },
  },

  en: {
    meta: {
      title: "FLEN Immobilier | Your real estate partner in Switzerland",
      description: "FLEN Immobilier supports you in selling, acquiring and investing in real estate with expertise, rigour and discretion.",
    },
    nav: {
      expertise: "Expertise",
      about: "About",
      contact: "Contact",
      cta: "Let's talk about your project",
      openMenu: "Open menu",
      closeMenu: "Close menu",
    },
    hero: {
      line1: "Real estate,",
      line2: "reimagined.",
      sub: "Sell · Acquire · Invest",
      cta: "Let's talk about your project",
      scroll: "Scroll to explore",
      alt: "Modern Swiss villa at dusk — contemporary architecture",
    },
    intro: {
      label: "FLEN Immobilier",
      headline: "A different way of thinking about real estate.",
      text: "FLEN Immobilier supports its clients in their real estate projects with an approach founded on listening, precision and discretion.",
    },
    marquee: ["Sell", "Acquire", "Invest", "Valuation", "Advisory", "Discretion"],
    expertise: {
      label: "What we do",
      headline: "Our expertise",
      items: [
        {
          num: "01",
          title: "Sell",
          text: "A tailor-made strategy to reveal the value of your property and reach the right buyers.",
        },
        {
          num: "02",
          title: "Acquire",
          text: "A rigorous selection and personalised support to find the property that truly suits you.",
        },
        {
          num: "03",
          title: "Invest",
          text: "A strategic vision of real estate to identify opportunities and create value.",
        },
      ],
    },
    emotional: {
      headline: "Excellence in every detail.",
      text: "From the first meeting to the signature, every project deserves particular attention.",
      alt: "Shores of Lake Geneva — Swiss landscape by the water",
    },
    approach: {
      label: "Why FLEN",
      headline: "Our approach",
      items: [
        { num: "01", title: "Expertise", text: "A precise knowledge of the market." },
        { num: "02", title: "Discretion", text: "Confidential and personalised exchanges." },
        { num: "03", title: "Excellence", text: "Every detail matters." },
        { num: "04", title: "Commitment", text: "Support at every step." },
      ],
    },
    cta: {
      headline: "Your project deserves a different approach.",
      sub: "Let's talk.",
      button: "Get in touch",
    },
    contact: {
      label: "Contact",
      headline: "Let's talk about your project.",
      subtitle: "Looking to sell, acquire or invest? Let's talk in complete confidentiality.",
      firstName: "First name",
      lastName: "Last name",
      email: "E-mail",
      phone: "Phone",
      project: "Your project",
      projectOptions: ["Sale", "Acquisition", "Investment", "Valuation", "Other"],
      message: "Message",
      submit: "Send my request",
      sending: "Sending…",
      successTitle: "Thank you for your message.",
      successText: "We will get back to you as soon as possible.",
      errorText: "Something went wrong. Please try again or write to us directly by e-mail.",
      required: "This field is required.",
      propertyInquiry: "Property",
      emailLabel: "E-mail",
      phoneLabel: "Phone",
      locationLabel: "Address",
      locationValue: "Avenue de Granges-Paccot 2 · 1700 Fribourg",
    },
    footer: {
      navTitle: "Navigation",
      contactTitle: "Contact",
      home: "Home",
      legalMentions: "Legal notice",
      legalPrivacy: "Privacy policy",
      rights: "© 2026 FLEN Immobilier",
      email: "info@flen-immobilier.ch",
      location: "Avenue de Granges-Paccot 2 · 1700 Fribourg",
    },
    legal: {
      backHome: "Back to home",
      updated: "Last updated: August 2026",
      mentions: {
        title: "Legal notice",
        sections: [
          {
            h: "Website publisher",
            p: "FLEN Immobilier\nAvenue de Granges-Paccot 2\n1700 Fribourg, Switzerland\nE-mail: info@flen-immobilier.ch\nCompany registration number (IDE/UID): CHE-419.152.950",
          },
          {
            h: "Intellectual property",
            p: "All content on this website (texts, images, logotypes, graphic elements) is the exclusive property of FLEN Immobilier. Any reproduction, distribution or use without prior written authorisation is prohibited.",
          },
          {
            h: "Limitation of liability",
            p: "FLEN Immobilier strives to ensure the accuracy of the information published, but cannot guarantee its completeness or currency. Liability for damages arising from the use of this website is excluded to the extent permitted by law. This website may contain links to third-party websites, for which FLEN Immobilier declines all responsibility.",
          },
          {
            h: "Applicable law",
            p: "This website and this legal notice are governed by Swiss law. The exclusive place of jurisdiction is Fribourg, subject to mandatory jurisdictions.",
          },
        ],
      },
      privacy: {
        title: "Privacy policy",
        sections: [
          {
            h: "Data controller",
            p: "FLEN Immobilier, Avenue de Granges-Paccot 2, 1700 Fribourg, Switzerland (info@flen-immobilier.ch), is responsible for processing the personal data collected via this website, in accordance with the Swiss Federal Act on Data Protection (revFADP).",
          },
          {
            h: "Data collected",
            p: "When you use our contact form, we collect the data you submit: first name, last name, e-mail address, phone number (optional), project type and message. This data is used exclusively to process your request and to contact you.",
          },
          {
            h: "Disclosure to third parties",
            p: "Your data is neither sold nor disclosed to third parties for commercial purposes. It may be processed by technical service providers (website hosting, e-mail delivery service) strictly to the extent required to operate our services.",
          },
          {
            h: "Usage analytics",
            p: "This website uses an audience analytics tool to improve the user experience. Data collected for this purpose is processed in aggregate form.",
          },
          {
            h: "Retention period",
            p: "We retain your data only for as long as necessary to process your request and any resulting exchanges, unless a longer retention period is required by law.",
          },
          {
            h: "Your rights",
            p: "You have the right to access, rectify and delete your personal data. To exercise these rights or for any data protection question, write to us at info@flen-immobilier.ch.",
          },
          {
            h: "Changes",
            p: "FLEN Immobilier reserves the right to amend this privacy policy. The version published on this website applies.",
          },
        ],
      },
    },
  },
};

export const propertiesI18n = {
  fr: {
    navLabel: "Propriétés",
    pageLabel: "Portfolio",
    headline: "Nos propriétés",
    sub: "Une sélection de biens actuellement disponibles à la vente.",
    allCategories: "Toutes catégories",
    categoryLabel: "Catégorie",
    priceFrom: "Prix min.",
    priceTo: "Prix max.",
    roomsFrom: "Pièces min.",
    locationLabel: "Lieu",
    locationPlaceholder: "Ville, NPA…",
    sortLabel: "Trier",
    sortNewest: "Plus récentes",
    sortPriceAsc: "Prix croissant",
    sortPriceDesc: "Prix décroissant",
    reset: "Réinitialiser",
    countOne: "1 propriété",
    countMany: "{n} propriétés",
    sale: "Vente",
    sold: "Vendu",
    forSale: "À vendre",
    soldMenu: "Vendues",
    rental: "Location",
    rentalMenu: "À louer",
    rentalBack: "Tous les biens à louer",
    rented: "Loué",
    rentalHeadline: "Biens à louer",
    rentalSub: "Une sélection de biens actuellement disponibles à la location.",
    rentalEmptyAll: "Aucun bien à louer disponible pour le moment.",
    rentalPriceFrom: "Loyer min.",
    rentalPriceTo: "Loyer max.",
    grossRentLabel: "Loyer brut",
    netRentLabel: "Loyer net",
    annualRentLabel: "Loyer annuel",
    rentalRateLabel: "Loyer commercial",
    chargesLabel: "Charges",
    depositLabel: "Dépôt de garantie",
    perMonth: "/ mois",
    perYear: "/ an",
    perSqmYear: "/ m² / an",
    rentalInquiryType: "Location",
    availabilityStatus: {
      available: "immédiatement",
      by_agreement: "Sur demande",
      from_date: "Disponible dès",
      rented: "Loué",
    },
    soldHeadline: "Propriétés vendues",
    soldSub: "Notre portefeuille de référence — des objets que nous avons vendus avec succès pour nos clients.",
    emptySold: "Aucune propriété vendue pour le moment — notre portefeuille de référence s'enrichira prochainement.",
    soldOn: "Vendu le",
    details: "Détails",
    roomsUnit: "pièces",
    areaUnit: "m²",
    empty: "Aucune propriété ne correspond à vos critères.",
    emptyAll: "Aucune propriété disponible pour le moment.",
    back: "Toutes les propriétés",
    factsTitle: "Caractéristiques",
    descriptionTitle: "Description",
    priceLabel: "Prix",
    roomsLabel: "Pièces",
    areaLabel: "Surface",
    locationFactLabel: "Lieu",
    contactCta: "Ce bien vous intéresse ?",
    contactBtn: "Parlons de votre projet",
    notFound: "Cette propriété n'est plus disponible.",
    availabilityLabel: "Disponible dès",
    featuresTitle: "Équipement",
    floorLabel: "Étage",
    yearBuiltLabel: "Année de construction",
    renovationLabel: "Année de rénovation",
    landAreaLabel: "Surface du terrain",
    livingAreaLabel: "Surface habitable nette",
    usableAreaLabel: "Surface utile",
    inquiryTitle: "Intéressé par ce bien ?",
    inquirySub: "Écrivez-nous — nous revenons vers vous dans les meilleurs délais.",
    messagePlaceholder: "Votre message…",
    categories: { apartment: "Appartement", house: "Maison", villa: "Villa", plot: "Terrain", building: "Immeuble", commercial: "Commercial", approved_projects: "Projet autorisé" },
  },
  de: {
    navLabel: "Objekte",
    pageLabel: "Portfolio",
    headline: "Unsere Objekte",
    sub: "Eine Auswahl aktuell zum Verkauf stehender Immobilien.",
    allCategories: "Alle Kategorien",
    categoryLabel: "Kategorie",
    priceFrom: "Preis von",
    priceTo: "Preis bis",
    roomsFrom: "Zimmer von",
    locationLabel: "Ort",
    locationPlaceholder: "Ort, PLZ…",
    sortLabel: "Sortierung",
    sortNewest: "Neueste",
    sortPriceAsc: "Preis aufsteigend",
    sortPriceDesc: "Preis absteigend",
    reset: "Zurücksetzen",
    countOne: "1 Objekt",
    countMany: "{n} Objekte",
    sale: "Kauf",
    sold: "Verkauft",
    forSale: "Zum Verkauf",
    soldMenu: "Verkauft",
    rental: "Miete",
    rentalMenu: "Zu mieten",
    rentalBack: "Alle Mietobjekte",
    rented: "Vermietet",
    rentalHeadline: "Immobilien mieten",
    rentalSub: "Eine Auswahl aktuell zur Miete verfügbarer Immobilien.",
    rentalEmptyAll: "Aktuell sind keine Mietobjekte verfügbar.",
    rentalPriceFrom: "Miete von",
    rentalPriceTo: "Miete bis",
    grossRentLabel: "Bruttomiete",
    netRentLabel: "Nettomiete",
    annualRentLabel: "Jahresmiete",
    rentalRateLabel: "Gewerbemiete",
    chargesLabel: "Nebenkosten",
    depositLabel: "Mietkaution",
    perMonth: "/ Monat",
    perYear: "/ Jahr",
    perSqmYear: "/ m² / Jahr",
    rentalInquiryType: "Miete",
    availabilityStatus: {
      available: "sofort",
      by_agreement: "Nach Vereinbarung",
      from_date: "Verfügbar ab",
      rented: "Vermietet",
    },
    soldHeadline: "Verkaufte Objekte",
    soldSub: "Unser Referenz-Portfolio — Objekte, die wir für unsere Kunden erfolgreich verkauft haben.",
    emptySold: "Aktuell keine verkauften Objekte — unser Referenz-Portfolio wächst in Kürze.",
    soldOn: "Verkauft am",
    details: "Details",
    roomsUnit: "Zimmer",
    areaUnit: "m²",
    empty: "Keine Objekte entsprechen Ihren Kriterien.",
    emptyAll: "Aktuell sind keine Objekte verfügbar.",
    back: "Alle Objekte",
    factsTitle: "Eckdaten",
    descriptionTitle: "Beschreibung",
    priceLabel: "Preis",
    roomsLabel: "Zimmer",
    areaLabel: "Fläche",
    locationFactLabel: "Ort",
    contactCta: "Interessiert an diesem Objekt?",
    contactBtn: "Sprechen wir über Ihr Projekt",
    notFound: "Dieses Objekt ist nicht mehr verfügbar.",
    availabilityLabel: "Verfügbar ab",
    featuresTitle: "Ausstattung",
    floorLabel: "Etage",
    yearBuiltLabel: "Baujahr",
    renovationLabel: "Renovationsjahr",
    landAreaLabel: "Grundstücksfläche",
    livingAreaLabel: "Nettowohnfläche",
    usableAreaLabel: "Nutzfläche",
    inquiryTitle: "Interessiert an diesem Objekt?",
    inquirySub: "Schreiben Sie uns — wir melden uns zeitnah bei Ihnen.",
    messagePlaceholder: "Ihre Nachricht…",
    categories: { apartment: "Wohnung", house: "Haus", villa: "Villa", plot: "Bauland", building: "Mehrfamilienhaus", commercial: "Gewerbeobjekt", approved_projects: "Bewilligtes Bauprojekt" },
  },
  en: {
    navLabel: "Properties",
    pageLabel: "Portfolio",
    headline: "Our properties",
    sub: "A selection of properties currently available for sale.",
    allCategories: "All categories",
    categoryLabel: "Category",
    priceFrom: "Min. price",
    priceTo: "Max. price",
    roomsFrom: "Min. rooms",
    locationLabel: "Location",
    locationPlaceholder: "City, ZIP…",
    sortLabel: "Sort",
    sortNewest: "Newest",
    sortPriceAsc: "Price ascending",
    sortPriceDesc: "Price descending",
    reset: "Reset",
    countOne: "1 property",
    countMany: "{n} properties",
    sale: "Sale",
    sold: "Sold",
    forSale: "For sale",
    soldMenu: "Sold",
    rental: "Rent",
    rentalMenu: "For rent",
    rentalBack: "All rental properties",
    rented: "Rented",
    rentalHeadline: "Properties for rent",
    rentalSub: "A selection of properties currently available for rent.",
    rentalEmptyAll: "No rental properties available at the moment.",
    rentalPriceFrom: "Min. rent",
    rentalPriceTo: "Max. rent",
    grossRentLabel: "Gross rent",
    netRentLabel: "Net rent",
    annualRentLabel: "Annual rent",
    rentalRateLabel: "Commercial rent",
    chargesLabel: "Charges",
    depositLabel: "Rental deposit",
    perMonth: "/ month",
    perYear: "/ year",
    perSqmYear: "/ m² / year",
    rentalInquiryType: "Rental",
    availabilityStatus: {
      available: "immediately",
      by_agreement: "By agreement",
      from_date: "Available from",
      rented: "Rented",
    },
    soldHeadline: "Sold properties",
    soldSub: "Our reference portfolio — properties we have successfully sold for our clients.",
    emptySold: "No sold properties yet — our reference portfolio will grow soon.",
    soldOn: "Sold on",
    details: "Details",
    roomsUnit: "rooms",
    areaUnit: "m²",
    empty: "No properties match your criteria.",
    emptyAll: "No properties available at the moment.",
    back: "All properties",
    factsTitle: "Key facts",
    descriptionTitle: "Description",
    priceLabel: "Price",
    roomsLabel: "Rooms",
    areaLabel: "Area",
    locationFactLabel: "Location",
    contactCta: "Interested in this property?",
    contactBtn: "Let's talk about your project",
    notFound: "This property is no longer available.",
    availabilityLabel: "Available from",
    featuresTitle: "Features",
    floorLabel: "Floor",
    yearBuiltLabel: "Year built",
    renovationLabel: "Renovation year",
    landAreaLabel: "Land area",
    livingAreaLabel: "Net living area",
    usableAreaLabel: "Usable area",
    inquiryTitle: "Interested in this property?",
    inquirySub: "Write to us — we will get back to you shortly.",
    messagePlaceholder: "Your message…",
    categories: { apartment: "Apartment", house: "House", villa: "Villa", plot: "Plot", building: "Multi-family", commercial: "Commercial", approved_projects: "Approved project" },
  },
};

export const membersI18n = {
  fr: {
    navLabel: "Espace membres",
    loginTitle: "Espace membres",
    loginSub: "Accès réservé aux investisseurs validés par FLEN.",
    registerTitle: "Demande d'accès",
    registerSub: "Nos objets off-market sont réservés à des investisseurs sélectionnés. Chaque demande est vérifiée personnellement.",
    tabLogin: "Connexion",
    tabRegister: "Demande d'accès",
    company: "Société",
    password: "Mot de passe",
    interests: "Quels types de biens vous intéressent ?",
    messageOpt: "Message (facultatif)",
    loginBtn: "Se connecter",
    registerBtn: "Envoyer ma demande",
    pending: "Votre demande est en cours de vérification. Nous revenons vers vous dans les meilleurs délais.",
    rejected: "Votre demande n'a pas été retenue. Contactez-nous pour plus d'informations.",
    invalid: "E-mail ou mot de passe incorrect.",
    exists: "Cette adresse e-mail est déjà enregistrée.",
    registerDone: "Merci pour votre demande.",
    registerDoneSub: "Nous vérifions votre inscription et vous contactons personnellement dès validation.",
    areaTitle: "Objets off-market",
    areaSub: "Une sélection confidentielle, réservée à nos membres.",
    empty: "Aucun objet off-market pour le moment.",
    confidential: "Contenu confidentiel — merci de ne pas le partager.",
    logout: "Déconnexion",
    welcome: "Bonjour",
    backToArea: "Tous les objets off-market",
    protectedNote: "Page protégée : filigrane personnel actif, captures et téléchargements découragés.",
    backHome: "Retour au site",
    forgotLink: "Mot de passe oublié ?",
    forgotTitle: "Réinitialiser le mot de passe",
    forgotSub: "Indiquez votre adresse e-mail — nous vous envoyons un lien de réinitialisation.",
    forgotBtn: "Envoyer le lien",
    forgotDone: "Si un compte existe pour cette adresse, le lien est en route.",
    backToLogin: "Retour à la connexion",
    resetTitle: "Nouveau mot de passe",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le mot de passe",
    resetBtn: "Enregistrer",
    resetDone: "Votre mot de passe a été mis à jour.",
    resetInvalid: "Ce lien est invalide ou expiré. Demandez un nouveau lien.",
    mismatch: "Les mots de passe ne correspondent pas.",
    avatarLabel: "Photo / Logo",
    avatarChange: "Modifier",
    avatarAdd: "Ajouter une photo",
    inquiredBadge: "Demande envoyée",
    dashboardSub: "Votre espace personnel — vos informations et vos objets off-market.",
    yourDetails: "Vos coordonnées",
    memberSince: "Membre depuis",
    yourInterests: "Vos intérêts",
    allInterests: "Tous les objets",
    statInquiries: "Demandes envoyées",
    statOpen: "En attente de réponse",
    statAnswered: "Réponses reçues",
    statViews: "Objets consultés",
    forYou: "Pour vous",
    forYouSub: "Une sélection basée sur vos intérêts.",
    noMatches: "Aucun objet ne correspond à vos intérêts pour le moment.",
    showAll: "Voir tout le portfolio off-market",
    hideAll: "Réduire",
    allTitle: "Tout le portfolio off-market",
    newBadge: "Nouveau",
    newSinceOne: "1 nouvel objet depuis votre dernière visite",
    newSinceMany: "{n} nouveaux objets depuis votre dernière visite",
    watermarkCaption: "Exclusivité FLEN · {email}",
    interested: "Ce bien m'intéresse",
    messages: "Messages",
    typeMessage: "Votre message…",
    send: "Envoyer",
    chatEmpty: "Écrivez votre première question — nous répondons personnellement.",
    replyTime: "Réponse personnelle sous 24 h",
    you: "Vous",
  },
  de: {
    navLabel: "Member-Bereich",
    loginTitle: "Member-Bereich",
    loginSub: "Zugang nur für von FLEN geprüfte Investoren.",
    registerTitle: "Zugang anfordern",
    registerSub: "Unsere Off-Market-Objekte sind ausgewählten Investoren vorbehalten. Jede Anfrage wird persönlich geprüft.",
    tabLogin: "Anmeldung",
    tabRegister: "Zugang anfordern",
    company: "Firma",
    password: "Passwort",
    interests: "Welche Objekttypen interessieren Sie?",
    messageOpt: "Nachricht (optional)",
    loginBtn: "Anmelden",
    registerBtn: "Anfrage senden",
    pending: "Ihre Anfrage wird geprüft. Wir melden uns zeitnah bei Ihnen.",
    rejected: "Ihre Anfrage wurde nicht berücksichtigt. Kontaktieren Sie uns für weitere Informationen.",
    invalid: "E-Mail oder Passwort falsch.",
    exists: "Diese E-Mail-Adresse ist bereits registriert.",
    registerDone: "Vielen Dank für Ihre Anfrage.",
    registerDoneSub: "Wir prüfen Ihre Registrierung und kontaktieren Sie persönlich nach der Freischaltung.",
    areaTitle: "Off-Market-Objekte",
    areaSub: "Eine vertrauliche Auswahl, nur für unsere Mitglieder.",
    empty: "Aktuell keine Off-Market-Objekte verfügbar.",
    confidential: "Vertraulicher Inhalt — bitte nicht weitergeben.",
    logout: "Abmelden",
    welcome: "Guten Tag",
    backToArea: "Alle Off-Market-Objekte",
    protectedNote: "Geschützte Seite: persönliches Wasserzeichen aktiv, Screenshots und Downloads unerwünscht.",
    backHome: "Zurück zur Website",
    forgotLink: "Passwort vergessen?",
    forgotTitle: "Passwort zurücksetzen",
    forgotSub: "Geben Sie Ihre E-Mail-Adresse ein — wir senden Ihnen einen Link.",
    forgotBtn: "Link senden",
    forgotDone: "Falls ein Konto mit dieser Adresse existiert, ist der Link unterwegs.",
    backToLogin: "Zurück zur Anmeldung",
    resetTitle: "Neues Passwort",
    newPassword: "Neues Passwort",
    confirmPassword: "Passwort bestätigen",
    resetBtn: "Speichern",
    resetDone: "Ihr Passwort wurde aktualisiert.",
    resetInvalid: "Dieser Link ist ungültig oder abgelaufen. Fordern Sie einen neuen Link an.",
    mismatch: "Die Passwörter stimmen nicht überein.",
    avatarLabel: "Foto / Logo",
    avatarChange: "Ändern",
    avatarAdd: "Foto hochladen",
    inquiredBadge: "Anfrage gesendet",
    dashboardSub: "Ihr persönlicher Bereich — Ihre Angaben und Off-Market-Objekte.",
    yourDetails: "Ihre Angaben",
    memberSince: "Mitglied seit",
    yourInterests: "Ihre Interessen",
    allInterests: "Alle Objekte",
    statInquiries: "Anfragen gesendet",
    statOpen: "Offen",
    statAnswered: "Antworten erhalten",
    statViews: "Objekte angesehen",
    forYou: "Für Sie",
    forYouSub: "Eine Auswahl basierend auf Ihren Interessen.",
    noMatches: "Aktuell keine Objekte passend zu Ihren Interessen.",
    showAll: "Gesamtes Off-Market-Portfolio anzeigen",
    hideAll: "Reduzieren",
    allTitle: "Gesamtes Off-Market-Portfolio",
    newBadge: "Neu",
    newSinceOne: "1 neues Objekt seit Ihrem letzten Besuch",
    newSinceMany: "{n} neue Objekte seit Ihrem letzten Besuch",
    watermarkCaption: "FLEN Exklusivität · {email}",
    interested: "Dieses Objekt interessiert mich",
    messages: "Nachrichten",
    typeMessage: "Ihre Nachricht…",
    send: "Senden",
    chatEmpty: "Schreiben Sie Ihre erste Frage — wir antworten persönlich.",
    replyTime: "Persönliche Antwort innert 24 Stunden",
    you: "Sie",
  },
  en: {
    navLabel: "Member area",
    loginTitle: "Member area",
    loginSub: "Access reserved for investors approved by FLEN.",
    registerTitle: "Request access",
    registerSub: "Our off-market properties are reserved for selected investors. Every request is reviewed personally.",
    tabLogin: "Sign in",
    tabRegister: "Request access",
    company: "Company",
    password: "Password",
    interests: "Which types of properties interest you?",
    messageOpt: "Message (optional)",
    loginBtn: "Sign in",
    registerBtn: "Send my request",
    pending: "Your request is being reviewed. We will get back to you shortly.",
    rejected: "Your request was not approved. Contact us for more information.",
    invalid: "Incorrect e-mail or password.",
    exists: "This e-mail address is already registered.",
    registerDone: "Thank you for your request.",
    registerDoneSub: "We are reviewing your registration and will contact you personally once approved.",
    areaTitle: "Off-market properties",
    areaSub: "A confidential selection, reserved for our members.",
    empty: "No off-market properties at the moment.",
    confidential: "Confidential content — please do not share.",
    logout: "Sign out",
    welcome: "Hello",
    backToArea: "All off-market properties",
    protectedNote: "Protected page: personal watermark active, screenshots and downloads discouraged.",
    backHome: "Back to website",
    forgotLink: "Forgot password?",
    forgotTitle: "Reset password",
    forgotSub: "Enter your e-mail address — we will send you a reset link.",
    forgotBtn: "Send link",
    forgotDone: "If an account exists for this address, the link is on its way.",
    backToLogin: "Back to sign in",
    resetTitle: "New password",
    newPassword: "New password",
    confirmPassword: "Confirm password",
    resetBtn: "Save",
    resetDone: "Your password has been updated.",
    resetInvalid: "This link is invalid or has expired. Please request a new one.",
    mismatch: "Passwords do not match.",
    avatarLabel: "Photo / logo",
    avatarChange: "Change",
    avatarAdd: "Upload photo",
    inquiredBadge: "Inquiry sent",
    dashboardSub: "Your personal area — your details and off-market properties.",
    yourDetails: "Your details",
    memberSince: "Member since",
    yourInterests: "Your interests",
    allInterests: "All properties",
    statInquiries: "Inquiries sent",
    statOpen: "Awaiting reply",
    statAnswered: "Replies received",
    statViews: "Properties viewed",
    forYou: "For you",
    forYouSub: "A selection based on your interests.",
    noMatches: "No properties match your interests at the moment.",
    showAll: "View the full off-market portfolio",
    hideAll: "Show less",
    allTitle: "Full off-market portfolio",
    newBadge: "New",
    newSinceOne: "1 new property since your last visit",
    newSinceMany: "{n} new properties since your last visit",
    watermarkCaption: "FLEN exclusive · {email}",
    interested: "I'm interested in this property",
    messages: "Messages",
    typeMessage: "Your message…",
    send: "Send",
    chatEmpty: "Write your first question — we reply personally.",
    replyTime: "Personal reply within 24 hours",
    you: "You",
  },
};
